// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"bcd447f2","437":"d2930b1a","646":"87048c0f"}[chunkId] + ".chunk.js";
};